import { Col } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}
export const SkinAndMucousSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const hasSkinAndMucousSymptoms = symptoms.skinAndMucous?.status === 'yes'

  const rashesLabel = t('epidemiology.symptoms.skinAndMucous.rashes')
  const injuriesLabel = t('epidemiology.symptoms.skinAndMucous.injuries')
  const appearanceDateLabel = t('epidemiology.symptoms.appearanceDate')

  return (
    <>
      <Col span={24}>
        <Text>
          {`2. ${t('epidemiology.skin_and_mucous')}`}:{' '}
          <Text weight={400}>
            {t(
              `epidemiology.symptoms.general.${symptoms.skinAndMucous?.status}`
            )}
          </Text>
        </Text>
      </Col>

      {hasSkinAndMucousSymptoms && (
        <>
          {symptoms.skinAndMucous?.rashes?.isSelected && (
            <>
              <Col span={8}>
                <Text>
                  {rashesLabel}

                  {symptoms.skinAndMucous.rashes.appearanceDate?.value && (
                    <>
                      {' - '}
                      <Text weight={400}>
                        {appearanceDateLabel}:{' '}
                        {dayjs(
                          symptoms.skinAndMucous.rashes.appearanceDate.value
                        ).format(dayMonthYearFormatWithDot)}
                      </Text>
                    </>
                  )}
                </Text>
              </Col>

              {symptoms.skinAndMucous.rashes.maculoPapular?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.maculoPapular')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.microPapular?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.microPapular')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.vesicles?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.vesicles')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.hemoragic?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.hemoragic')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.petehii?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.petehii')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.eritem?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.eritem')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.rashes.pustule?.isSelected && (
                <Col span={8}>
                  <Text>
                    {rashesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.pustule')}
                  </Text>
                </Col>
              )}
            </>
          )}

          {symptoms.skinAndMucous?.carbuncul?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.skinAndMucous.carbuncul')}</Text>
            </Col>
          )}

          {symptoms.skinAndMucous?.sancru?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.skinAndMucous.sancru')}</Text>
            </Col>
          )}

          {symptoms.skinAndMucous?.icter?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.skinAndMucous.icter')}

                {symptoms.skinAndMucous.icter.appearanceDate?.value && (
                  <>
                    {' - '}
                    <Text weight={400}>
                      {appearanceDateLabel}:{' '}
                      {dayjs(
                        symptoms.skinAndMucous.icter.appearanceDate.value
                      ).format(dayMonthYearFormatWithDot)}
                    </Text>
                  </>
                )}
              </Text>
            </Col>
          )}

          {symptoms.skinAndMucous?.injuries?.isSelected && (
            <>
              <Col span={8}>
                <Text>
                  {injuriesLabel}

                  {symptoms.skinAndMucous.injuries.appearanceDate?.value && (
                    <>
                      {' - '}
                      <Text weight={400}>
                        {appearanceDateLabel}:{' '}
                        {dayjs(
                          symptoms.skinAndMucous.injuries.appearanceDate.value
                        ).format(dayMonthYearFormatWithDot)}
                      </Text>
                    </>
                  )}
                </Text>
              </Col>

              {symptoms.skinAndMucous.injuries.animalBite?.isSelected && (
                <Col span={8}>
                  <Text>
                    {injuriesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.animalBite')}
                  </Text>
                </Col>
              )}

              {symptoms.skinAndMucous.injuries.arthropodBite?.isSelected && (
                <Col span={8}>
                  <Text>
                    {injuriesLabel} -{' '}
                    {t('epidemiology.symptoms.skinAndMucous.arthropodBite')}
                  </Text>
                </Col>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
